import script from "./PostView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostView.vue?vue&type=script&setup=true&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=33f4e2a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f4e2a0"]])

export default __exports__